import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageIntro from '@/components/feature/PageIntro';
import CTASection from '@/components/feature/CTASection';
import OpenRotorMark from '@/components/base/OpenRotorMark';
import { aboutPoints, principles } from '@/mocks/pages';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="bg-background-50 pt-16 md:pt-20">
        <PageIntro crumb="About" eyebrow="About NORTHLINE" title="PRECISION IN EVERY CONNECTION." docTitle="About | NORTHLINE Flow Systems">
          <p>NORTHLINE is an industrial valve and flow-control component supplier, helping B2B buyers source the right components with clear information and coordinated support.</p>
        </PageIntro>

        <section className="max-w-[1200px] mx-auto px-5 md:px-10 pb-20 md:pb-28">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 border-t border-background-200 pt-14 md:pt-20">
            <div className="lg:col-span-5">
              <p className="eyebrow text-primary-500">Who we are</p>
              <h2 data-mo="title" className="mt-5 font-heading text-3xl md:text-4xl tracking-[-0.02em] text-foreground-950">A supplier focused on the details between requirement and order.</h2>
            </div>
            <div data-mo="group" className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-10">
              {aboutPoints.map((p) => (
                <div key={p.title}>
                  <h3 className="text-lg font-medium text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-foreground-600">{p.body}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-[1200px] mx-auto px-5 md:px-10 pb-20 md:pb-28">
          <p className="eyebrow text-primary-500">Our approach</p>
          <div data-mo="group" className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            {principles.map((p) => (
              <div key={p.title} className="border-t border-foreground-950/80 pt-6">
                <h3 className="font-heading text-3xl md:text-4xl tracking-[-0.02em] text-foreground-950">{p.title}</h3>
                <p className="mt-4 text-[15px] leading-relaxed text-foreground-600 max-w-xs">{p.body}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-100/60 mb-20 md:mb-28">
          <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div data-mo="fade" className="lg:col-span-5 flex justify-center lg:justify-start">
              <OpenRotorMark size={240} title="NORTHLINE Open Rotor mark" className="w-[160px] h-[160px] md:w-[240px] md:h-[240px]" />
            </div>
            <div className="lg:col-span-7">
              <p className="eyebrow text-primary-500">Brand identity</p>
              <h2 data-mo="title" className="mt-5 font-heading text-3xl md:text-4xl tracking-[-0.02em] text-foreground-950">The Open Rotor.</h2>
              <p className="mt-5 t-body text-foreground-600 max-w-lg">Our mark draws on the handwheel and rotor of a valve: an open outer ring, three spokes and a central hub. The gaps in the ring suggest flow passing through, while the hub stands for the controlled connection at the centre of every line.</p>
            </div>
          </div>
        </section>

        <CTASection title="LET'S WORK THROUGH YOUR REQUIREMENTS." />
      </main>
      <Footer />
    </>
  );
}